var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useToggle } from '@hn-front/utils';
import { AccordionContainer, AccordionText, AccordionHeader, AccordionControlContainer, AccordionContentContainer, OpenIcon, } from './Common';
var GradeAccordion = function (_a) {
    var text = _a.text, children = _a.children, isOpen = _a.isOpen, rest = __rest(_a, ["text", "children", "isOpen"]);
    var _b = useToggle(isOpen), isToggled = _b.isToggled, toggle = _b.toggle;
    return (_jsxs(AccordionContainer, __assign({}, rest, { children: [_jsx(AccordionHeader, { children: _jsxs(AccordionControlContainer, __assign({ onClick: toggle }, { children: [_jsx(AccordionText, { children: text }, void 0), _jsx(OpenIcon, { open: isToggled }, void 0)] }), void 0) }, void 0), isToggled && (_jsx(AccordionContentContainer, { children: children }, void 0))] }), void 0));
};
export { GradeAccordion };
